export const SET_INGREDIENTS_LIST: 'SET_INGREDIENTS_LIST' = 'SET_INGREDIENTS_LIST';
export const SET_INGREDIENTS_LIST_IS_LOADING: 'SET_INGREDIENTS_LIST_IS_LOADING' = 'SET_INGREDIENTS_LIST_IS_LOADING';
export const SET_INGREDIENTS_LIST_IS_ERROR: 'SET_INGREDIENTS_LIST_IS_ERROR' = 'SET_INGREDIENTS_LIST_IS_ERROR';
export const SELECT_INGREDIENT: 'SELECT_INGREDIENT' = 'SELECT_INGREDIENT';
export const REMOVE_SELECTED_INGREDIENT: 'REMOVE_SELECTED_INGREDIENT' = 'REMOVE_SELECTED_INGREDIENT';
export const UPDATE_SELECTED_INGREDIENT: 'UPDATE_SELECTED_INGREDIENT' = 'UPDATE_SELECTED_INGREDIENT';
export const ADD_INGREDIENT_INTO_CONSTRUCTOR: 'ADD_INGREDIENT_INTO_CONSTRUCTOR' = 'ADD_INGREDIENT_INTO_CONSTRUCTOR';
export const REMOVE_INGREDIENT_FROM_CONSTRUCTOR: 'REMOVE_INGREDIENT_FROM_CONSTRUCTOR' = 'REMOVE_INGREDIENT_FROM_CONSTRUCTOR';
export const CLEAR_CONSTRUCTOR: 'CLEAR_CONSTRUCTOR' = 'CLEAR_CONSTRUCTOR';

export const SET_USER: 'SET_USER' = 'SET_USER';
export const REMOVE_USER: 'REMOVE_USER' = 'REMOVE_USER';

export const WS_CONNECTION_START: 'WS_CONNECTION_START' = 'WS_CONNECTION_START';
export const WS_CONNECTION_ERROR: 'WS_CONNECTION_ERROR' = 'WS_CONNECTION_ERROR';
export const WS_CONNECTION_SUCCESS: 'WS_CONNECTION_SUCCESS' = 'WS_CONNECTION_SUCCESS';
export const WS_GET_ORDERS: 'WS_GET_ORDERS' = 'WS_GET_ORDERS';
export const WS_CONNECTION_CLOSED: 'WS_CONNECTION_CLOSED' = 'WS_CONNECTION_CLOSED';
export const WS_SEND: 'WS_SEND' = 'WS_SEND';

export const SELECT_ORDER: 'SELECT_ORDER' = 'SELECT_ORDER';
export const REMOVE_SELECTED_ORDER: 'REMOVE_SELECTED_ORDER' = 'REMOVE_SELECTED_ORDER';
export const SET_ORDER_DETAILS: 'GET_ORDER_DETAILS' = 'GET_ORDER_DETAILS';
export const CLEAR_ORDER_DETAILS: 'CLEAR_ORDER_DETAILS' = 'CLEAR_ORDER_DETAILS';
